import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Participation } from '@app/api';
import { AppliedParticipationCard } from '../../Home/components/AppliedParticipationCard';
import { InformationBox } from '@app/core';
import { useTranslation } from 'react-i18next';
import { EmptyState } from './EmptyState';
import InboxInk from '@app/illu/Small/InboxInk.svg';
import { StudiesCardContainer } from './StudiesCardContainer';

const useStyles = createUseStyles((theme: Theme) => ({
  informationContainer: {
    width: '100%',
    flexDirection: 'column',
    gap: theme.marginBase,
    color: 'red',
    [theme.media.largeScreen]: {
      flexDirection: 'row',
    },
  },
  informationText: {
    color: theme.colors.inkPrimary,
  },
  cardContainer: {
    width: '100%',
    maxWidth: theme.maxContentWidth.reduced,
    minWidth: 'auto',
    overflow: 'hidden',
    borderRadius: theme.borderRadius.large,
    marginBottom: theme.marginBase,
    [theme.media.homeScreen]: {
      width: '100%',
      minWidth: 'auto',
    },
  },
}));

interface Props {
  participations: Participation[];
}

export const StudiesApplied = ({ participations }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const noParticipation = !participations || participations.length === 0;

  return (
    <StudiesCardContainer noParticipation={noParticipation}>
      <InformationBox className={classes.informationContainer}>
        <p className={classes.informationText}>
          {t('home.applied.information')}
        </p>
      </InformationBox>
      {noParticipation ? (
        <EmptyState
          illustration={InboxInk}
          alt="Inbox"
          title={t('studies.empty.applied.title')}
          description={t('studies.empty.applied.description')}
        />
      ) : (
        participations.map((participation) => {
          return (
            <AppliedParticipationCard
              key={participation.id}
              participation={participation}
              className={classes.cardContainer}
            />
          );
        })
      )}
    </StudiesCardContainer>
  );
};
